import React from "react";
import { UpgradeSecurityPlanShared } from "app/components/upgrade-security-plan-shared";

export const UpgradeSecurityPlan = () => {
  return (
    <UpgradeSecurityPlanShared 
      fromPage="multi-network-selection-upgrade-security-plan"
      triggerClassName="inline-block text-[#FE4D01] text-sm sm:text-[0.925rem] lg:text-base font-semibold leading-4 sm:leading-5 lg:leading-6 cursor-pointer underline decoration-solid decoration-skip-ink decoration-[auto] underline-offset-[auto] [text-underline-position:from-font]"
      triggerText="Upgrade"
    />
  );
};
